import * as firebase from 'firebase'


var firebaseApp = null,

initFirebase = config => {
  // console.log(firebase)
  if (firebase.apps.length < 1)
    firebaseApp = firebase.initializeApp(config)
  else 
    firebaseApp = firebase.apps[0]
}

export { firebaseApp, initFirebase }